import React from "react";

const TripOperatorInfo = ({ data, carrier, getLastDate, t }) => {
  return (
    <div className="grid grid-cols-2 gap-1 border border-slate-200 border-t-0 border-l-0 border-r-0 my-2 pb-1">
      <div className="flex flex-col">
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("modalDetailTrip.carrier")}:{" "}
          </p>
          <p className="font-[Gravity]">{carrier}</p>
        </div>
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("modalDetailTrip.last_actualization")}:{" "}
          </p>
          <p className="font-[Gravity]">{getLastDate()}</p>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("modalDetailTrip.operator")}
          </p>
          <p className="font-[Gravity]">
            {data?.operator?.user?.name} {data?.operator?.user?.lastName}{" "}
            {data?.operator?.user?.secondLastName}
          </p>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div className="bg-[#FFBB35] rounded-full p-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 150 150"
              fill="#FFBB35"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Iconografia">
                <g id="icono_alerta">
                  <g id="Group 39">
                    <path
                      id="Vector (Stroke)"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M75.0003 48.0952C76.1838 48.0952 77.1431 49.0546 77.1431 50.2381V91.9047C77.1431 93.0882 76.1838 94.0476 75.0003 94.0476C73.8168 94.0476 72.8574 93.0882 72.8574 91.9047V50.2381C72.8574 49.0546 73.8168 48.0952 75.0003 48.0952Z"
                      fill="black"
                    />
                    <path
                      id="Vector_2"
                      d="M74.9993 125.238C79.6017 125.238 83.3327 121.507 83.3327 116.905C83.3327 112.302 79.6017 108.571 74.9993 108.571C70.397 108.571 66.666 112.302 66.666 116.905C66.666 121.507 70.397 125.238 74.9993 125.238Z"
                      fill="black"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div className="flex">
            <p className="font-[Gravity] font-bold mr-1">
              {data.noIncidents} Incidencias reportadas
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripOperatorInfo;
